import { Typography } from 'antd';
import * as React from 'react';

import { ColumnsIconType } from 'entities/TableColumn';
import { TableFactoryStoreParams } from 'stores/common';
import { translateApiValue } from 'utils/translateApiValue';

import s from './HeadingCell.module.scss';
import Tooltips from './Tooltips';

export type HeadingCellProps = {
  title: string;
  icons: ColumnsIconType[];
  tableParams: TableFactoryStoreParams;
};

const HeadingCell: React.FC<HeadingCellProps> = ({ title, icons }) => {
  const displayTooltips = icons.length > 0;

  return (
    <span className={s.cell}>
      <Typography.Text>{translateApiValue(title)}</Typography.Text>

      {displayTooltips && (
        <Tooltips className={s.cell__tooltips} icons={icons} />
      )}
    </span>
  );
};

export default React.memo(HeadingCell);
